const fs = require('fs');
const path = require('path');
const genmap = require('./generate_asset_map');

let prefix = '';

const manifestPath = path.resolve(__dirname, '..', 'dist', 'manifest.json');

function loadDiskManifest() {
  try {
    const json = fs.readFileSync(manifestPath, 'utf-8');
    return JSON.parse(json);
  } catch {
    return null;
  }
}

function get(name) {
  const disk = loadDiskManifest();
  if (disk && disk[name]) {
    return prefix + disk[name];
  }

  const manifest = typeof genmap === 'function' ? genmap() : genmap;
  if (!manifest[name]) {
    console.warn(`⚠️  assets.get(): "${name}" not found in manifest`);
    return prefix + name;
  }
  return prefix + manifest[name];
}

function match(regex) {
  const disk = loadDiskManifest();
  const manifest = disk || (typeof genmap === 'function' ? genmap() : genmap);
  return Object.keys(manifest)
    .filter(k => regex.test(k))
    .map(k => prefix + manifest[k]);
}

function setPrefix(p) {
  prefix = p;
}

function setMiddleware() {}

module.exports = {
  get,
  match,
  setPrefix,
  setMiddleware
};
